import axios from 'axios'
import store from '@/store'
import Router from '../router'
import dataModels from './dataModels'
import { getEnvVar } from '@/utils/envUtils'
import qs from 'qs'
import ApolloAPI from '@/api/apollo_api';

// FOR TESTING ONLY!!!!!
////////////////////////////////////////////////////////////
// const sleep = (delay) => {
//   return new Promise(function(resolve) {
//     setTimeout(resolve, delay);
//   });
// }

const CancelToken = axios.CancelToken
let cancels = {}

function getReqId(config) {
  return config.method + '_' + config.url.split('?')[0]
}
function cancelRequest(id) {
  if (cancels[id]) {
    // Lo he quitado, porque no funcionaba con los "mil" getTrial y getSubjects que hay ahora....
    // console.log("CANCELING",id)
    // cancels[id]()
  }
  cancels[id] = null
}

let Api = axios.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

let setHeaderToken = () => {
  if (localStorage.getItem('elem-session-token'))
    Api.defaults.headers.Authorization = 'Bearer ' + localStorage.getItem('elem-session-token')
}

setHeaderToken()

Api.interceptors.request.use(config => {
  /// CANCELABLE
  let reqId = getReqId(config)
  cancelRequest(reqId)
  config.cancelToken = new CancelToken(c => (cancels[reqId] = c))
  return config
})

Api.interceptors.response.use(
  function(response) {
    let reqId = getReqId(response.config)
    cancels[reqId] = null

    return response
  },
  function(error) {
    if (axios.isCancel(error)) {
      console.log('Request canceled', error.message)
      return Promise.reject(null)
    } else {
      // console.error(error)
      if (
        (error.response.status === 401) &&
        Router.history.current.path !== '/login'
      )
        Router.push({ path: '/login' })
      else return Promise.reject(error)
    }
  }
)

function downloadResponseAsFile(data, type, filename) {
  const file = new Blob([data], {type: type});
  //Build a URL from the file
  const fileURL = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = fileURL;
  var today = new Date()
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();

}
////////////////////////////////////////////////////////////

export default {
  ...dataModels,
  login(credentials) {
    let payload = new FormData()
    payload.append('username', credentials.username)
    payload.append('password', credentials.password)
    payload.append('client_secret', credentials.client_secret)
    return axios
      .post(getEnvVar('VUE_APP_API_URL') + '/login/access-token', payload, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then(response => {
          localStorage.setItem('elem-session-token', response.data.access_token)
          setHeaderToken()
        return response.data
      })
  },
  validateCredentials(credentials) {
    let payload = new FormData()
    payload.append('username', credentials.username)
    payload.append('password', credentials.password)
    return Api.post(getEnvVar('VUE_APP_API_URL') + '/login/credentials', payload, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(response => {
      return response.data
    })
  },
  generateQR(credentials) {
    let payload = new FormData()
    payload.append('username', credentials.username)
    payload.append('password', credentials.password)
    return Api.post(getEnvVar('VUE_APP_API_URL') + '/login/qr', payload).then(response => {
      return response.data
    })
  },
  userEnabledOTP(credentials) {
    let payload = new FormData()
    payload.append('username', credentials.username)
    payload.append('password', credentials.password)
    return Api.post(getEnvVar('VUE_APP_API_URL') + '/login/otp_enabled', payload).then(response => {
      return response.data
    }, error => store.dispatch('setError', error))
  },
  validateToken(token) {
    return axios.post(getEnvVar('VUE_APP_API_URL') + '/login/test-token')
  },

  getUser() {
    return Api.get(getEnvVar('VUE_APP_API_URL') + `/users/me`).then(response => {
      return response.data
    })
  },

  getOrganisationTokens() {
    return Api.get(getEnvVar('VUE_APP_API_URL') + `/users/organisation/tokens`).then(response => {
      return response.data
    }, error => store.dispatch('setError', error))
  },

  getProjects() {
    return Api.get(getEnvVar('VUE_APP_API_URL') + `/projects?skip=0&limit=-1`).then(response => {
      return response.data
    }, error => store.dispatch('setError', error))
  },

  getProject({ project }) {
    return Api.get(getEnvVar('VUE_APP_API_URL') + `/project/${project}`).then(response => {
      return response.data
    }, error => store.dispatch('setError', error))
  },

  postProject(newProject) {
    return Api.post(getEnvVar('VUE_APP_API_URL') + `/project`, newProject).then(response => {
      store.dispatch('projects/load')
      return response.data
    }, error => store.dispatch('setError', error))
  },
  putProject(project) {
    //Basura, hay que limpiar los "trials" ????
    project = JSON.parse(JSON.stringify(project))
    project.trials = null
    return Api.put(getEnvVar('VUE_APP_API_URL') + `/project/${project.id}`, project).then(
      response => {
        return response.data
      }, error => store.dispatch('setError', error)
    )
  },
  setProjectStatus(project, status) {
    //Basura, hay que limpiar los "trials" ????
    project = JSON.parse(JSON.stringify(project))
    project.status = status
    project.trials = null
    return Api.put(getEnvVar('VUE_APP_API_URL') + `/project/${project.id}`, project).then(
      response => {
        store.dispatch('projects/load')
        store.dispatch('paramsData/setValue', { key: 'project', value: response.data })
        return response.data
      }, error => store.dispatch('setError', error)
    )
  },
  postTrialSet(parameters) {
    return Api.post(getEnvVar('VUE_APP_API_URL') + `/trial/set`, parameters)
    .then(
      response => {
        return response.data, 
      error => store.dispatch('setError', error)
    })
  },
  getTrialSetTokens(parameters) {
    return Api.post(getEnvVar('VUE_APP_API_URL') + `/trial/set/cost`, parameters)
      .then(response => response.data, error => store.dispatch('setError', error))
  },
  postTrial(newTrial) {
    //Basura, hay que limpiar los "tokens" ???? (solo aplica en el caso del "dupliate")
    newTrial = JSON.parse(JSON.stringify(newTrial))
    if (newTrial.runConfig) newTrial.runConfig.computeTokens = null
    if (newTrial.cohortGeneration.population) newTrial.cohortGeneration.population.id = null
    return Api.post(
      getEnvVar('VUE_APP_API_URL') + `/project/${newTrial.projectId}/trial`,
      newTrial
    ).then(
      response => response.data, 
      error => store.dispatch('setError', error)
    )
  },
  cancelPutTrial(trial) {
    let url = getEnvVar('VUE_APP_API_URL') + `/project/${trial.projectId}/trial/${trial.id}`
    let reqId = getReqId({ method: 'put', url: url })
    cancelRequest(reqId)
  },
  putTrial(trial) {
    //Basura, hay que limpiar los "tokens" ????
    trial = JSON.parse(JSON.stringify(trial))
    if (trial.runConfig) trial.runConfig.computeTokens = null
    if (trial.cohortGeneration.population) trial.cohortGeneration.population.id = null

    return Api.put(
      getEnvVar('VUE_APP_API_URL') + `/project/${trial.projectId}/trial/${trial.id}`,
      trial
    ).then(response => {
      store.dispatch('paramsData/setValue', { key: 'trial', value: response.data })
      return response.data
    }, error => store.dispatch('setError', error))
  },
  setTrialStatus(trial, status) {
    return Api.post(
      getEnvVar('VUE_APP_API_URL') + `/project/${trial.projectId}/trial/${trial.id}/status`,
      `"${status}"`
    ).then(response => {
      trial.status = response.data
      store.dispatch('paramsData/setValue', { key: 'trial', value: trial })
      return response.data
    }, error => {
      store.dispatch('setError', error)
    })
  },
  setTrialSubmittedStatusCarrot(trial) {
    // Alternative call to VHeart to skip Trial info deployment to cluster, and set status to Deploying
    return Api.post(
      getEnvVar('VUE_APP_API_URL') + `/project/${trial.projectId}/trial/${trial.id}/set-submitted-status`
    ).then(response => {
      trial.status = response.data;
      store.dispatch('paramsData/setValue', { key: 'trial', value: trial });
      return response.data;
    }, error => {
      store.dispatch('setError', error);
    })
  },
  setTrialRunningStatusCarrot(trial) {
    // Alternative call to VHeart to skip legacy cluster simulation run
    return Api.post(
      getEnvVar('VUE_APP_API_URL') + `/project/${trial.projectId}/trial/${trial.id}/set-running-status`
    ).then(response => {
      trial.status = response.data;
      store.dispatch('paramsData/setValue', { key: 'trial', value: trial });
      return response.data;
    }, error => {
      store.dispatch('setError', error);
    })
  },
  getTrialCases(project,trial) {
    return Api.get(
      getEnvVar('VUE_APP_API_URL') + `/project/${project}/trial/${trial}/download`, {responseType: 'blob'}).then(
        response => {
          let fileName = `Project_${project}_Trial_${trial}.tar`
          downloadResponseAsFile(response.data, response.headers['content-type'], fileName)
        }, error => store.dispatch('setError', error)
      )
  },

  getTrialResults({ project, trial, filter }) {
    /// Gets the results for a trial. The filter might or might not be null. If it is not null it will be used to select the results to return.
    /// As specified by the backend, the {trial} item in the endpoint should be defined to -1 if more than one trial is to be searched.

    if (filter && trial != -1) filter.id = trial // if retrieving a single trial, must provide its id in the filter
    return ApolloAPI.getTrialResults(project, trial).then(response => {
      if (trial != -1) {
      /// retrieving a single trial (either whole project trial by trial, or retrieving a single trial)
        return this.getTrial({project, trial}).then(t => {
          response.data.forEach(result => {
            result.trialMeta = { id: trial, project: project, name: t.name, treatments: t.treatments }
          })
          return response.data
        }, error => store.dispatch('setError', error))
      } else {
      /// retrieving from different trials (filter is a group)
        let trialsInSearch = response.data.map(result => result.trialId)
        let uniqueTrialIds = trialsInSearch.filter((v, i, a) => a.indexOf(v) === i)
        let trialMetaPromises = uniqueTrialIds.map(trialId => this.getTrial({project: project, trial: trialId}))
        return Promise.all(trialMetaPromises).then(trialMetaResponse => {
          response.data.forEach(result => {
            let trialMetaForThisResult = trialMetaResponse.find(meta => meta.id == result.trialId)
            result.trialMeta = { 
              id: trialMetaForThisResult.id,
              project: trialMetaForThisResult.projectId,
              name: trialMetaForThisResult.name,
              treatments: trialMetaForThisResult.treatments
            }
          })
          return response.data
        }, error => store.dispatch('setError', error))
      }
    }, error => store.dispatch('setError', error))
  },

  getProjectResults(project, filter) {
    return this.getProject({ project }).then(p => {
      let trials = p.trials.filter(t => t.status === 'finished')
      if (filter && filter.trialIds) {
        filter.projectId = project
        if (typeof filter.id != 'string') trials = [{id: -1}] // user has selected a group
        else trials = trials.filter(t => filter.trialIds.includes(t.id)) // user has selected a trial
      }
      let promises = trials.map(t => {
        return this.getTrialResults({project: project, trial: t.id, filter: filter})
      })
      return Promise.all(promises).then(ress => {
        return ress.flat()
      }, error => store.dispatch('setError', error))
    }, error => store.dispatch('setError', error))
    // return Api
    //   .post(
    //     //getEnvVar('VUE_APP_LOCAL_DATA_URL') + `/project/${projectId}/cases_elem.json`,
    //     // getEnvVar('VUE_APP_LOCAL_DATA_URL') + `/project/${1}/cases_elem.json`
    //     //FAKE: hardcodeado porque aun no existe el endpoint
    //     getEnvVar('VUE_APP_API_URL') + `/project/${projectId}/trial/-1/subjects`
    //   )
    //   .then(response => {
    //     response.data.forEach((res)=>{
    //       // res.ecg = res.sparkline
    //       //BULLSHIT: faltan loas HEADERS!!!
    //       if(!res.sparkline.headers) res.sparkline.headers = ['Time','L1','L2','L3']
    //       res.trialMeta = {trialId:res.trialId,projectId:projectId,name:"FAKE TRIAL NAME"}
    //     })
    //     return response.data
    //   })
  },
  getProjectBaselines(projectId, populations) {
    return Api.post(
      getEnvVar('VUE_APP_API_URL') + `/project/${projectId}/baselines`, populations)
      .then(response => { return response.data }, 
        error => store.dispatch('setError', error))
  },
  getFilterTemplate(project) {
    return Api.get(
      //getEnvVar('VUE_APP_LOCAL_DATA_URL') + `/filterTemplate.json`
      getEnvVar('VUE_APP_API_URL') +
        `/project/${project.id}/groups/template?limit_to_completed_trials=false`
    ).then(response => {
      return response.data
    }, error => store.dispatch('setError', error))
  },
  getGroups(project) {
    return Api.get(getEnvVar('VUE_APP_API_URL') + `/project/${project.id}/groups`)
      .then(response => {
        return response.data
      }, error => store.dispatch('setError', error))
  },
  postGroup(project, groupBody) {
    return Api.post(getEnvVar('VUE_APP_API_URL') + `/project/${project.id}/groups`, groupBody).then(
      response => {
        return response.data
      }, error => store.dispatch('setError', error)
    )
  },
  deleteGroup(project, groupId) {
    return Api.delete(
      getEnvVar('VUE_APP_API_URL') + `/project/${project.id}/groups/${groupId}`
    ).then(response => {
      return response.data
    }, error => store.dispatch('setError', error))
  },
  applyFilter(filterConfig) {
    return Api.get(
      getEnvVar('VUE_APP_API_URL') + `/project/10/groups/template/?limit_to_completed_trials=false`,
      filterConfig
    ).then(response => {
      return response.data
    }, error => store.dispatch('setError', error))
  },
  //VERY FAKE!!!
  getFilteredResults(filterId) {
    return Api.get(getEnvVar('VUE_APP_LOCAL_DATA_URL') + `/project/1/${filterId}.json`).then(
      response => {
        return response.data
      }
    )
  },

  getProjectFields() {
    return Api.get(
      getEnvVar('VUE_APP_API_URL') + `/projectFields`
      //if release, use the following
      // getEnvVar('VUE_APP_API_URL') + `/projectFieldsRelease.json`
    ).then(response => {
      // return sleep(3000).then(()=>response.data)
      return response.data
    })
  },

  getTrial({ project, trial }) {
    return Api.get(getEnvVar('VUE_APP_API_URL') + `/project/${project}/trial/${trial}`).then(
      response => {
        return response.data
      }, error => store.dispatch('setError', error)
    )
  },
  // NO LO ESTAMOS USANDO porque "ya viene el status en la " /trial, no!?
  // getTrialStatus({project,trial}) {
  //   return Api
  //   .get(
  //     // getEnvVar('VUE_APP_LOCAL_DATA_URL') + `/trial/${trialId}.json`,
  //     getEnvVar('VUE_APP_API_URL') + `/project/${project}/trial/${trial}/status` ,

  //   )
  //   .then(response => {
  //     return response.data
  //   })
  // },

  // TODO: for case dashboard, getSubject is called from paramsData (also getTrial). getSubject basically gets whole trial and filters subject. 
    // Proposal: get subject directly from Apollo
  getSubject({ project, trial, subject }) {
    // return Api
    //   .get(
    //     getEnvVar('VUE_APP_LOCAL_DATA_URL') + `/case/${1}.json`,
    //   )
    //   .then(response => {
    //     return response.data
    //   })
    return this.getTrialResults({ project, trial }).then(res => {
      return res.find(s => String(s.subject.templateId) === String(subject))
    })
  },

  // Definitions
  getDefinitionList(listType) {
    return Api.get(
      //listType =="treatments" ?
      //  getEnvVar('VUE_APP_LOCAL_DATA_URL') + `/treatments.json` :
      getEnvVar('VUE_APP_API_URL') + '/' + listType
    ).then(response => {
      return response.data
    })
  },
  downloadTrialReport({ trial }) {
    return Api.get(getEnvVar('VUE_APP_API_URL') + `/statistics/report/trial/${trial}/`, {responseType: 'blob'}).then(
      response => {
        let today = new Date()
        let filename = `Report-${today.getFullYear() + "-" + today.getMonth() + "-" + today.getDay()}.pdf`
        downloadResponseAsFile(response.data, 'application/pdf', filename)
      }
    )
  },
  downloadGroupReport({ group }) {
    return Api.get(getEnvVar('VUE_APP_API_URL') + `/statistics/report/group/${group}/`, {responseType: 'blob'}).then(
      response => {
        let today = new Date()
        let filename = `Report-${today.getFullYear() + "-" + today.getMonth() + "-" + today.getDay()}.pdf`
        downloadResponseAsFile(response.data, 'application/pdf', filename)
      }
    )
  },
  /* downloadTrialCSV({ trial }) {
    return Api.get(getEnvVar('VUE_APP_API_URL') + `/export/trial/${trial}/`).then(
      response => {
        let filename = `trial_${trial}_global_vars.csv`
        downloadResponseAsFile(response.data, 'text/csv', filename)
      }
    )
  },
  downloadGroupCSV({ group }) {
    return Api.get(getEnvVar('VUE_APP_API_URL') + `/export/group/${group}/`).then(
      response => {
        let filename = `group_${group}_global_vars.csv`
        downloadResponseAsFile(response.data, 'text/csv', filename)
      }
    )
  },
  downloadProjectCSV({ project }) {
    return Api.get(getEnvVar('VUE_APP_API_URL') + `/export/project/${project}/`).then(
      response => {
        let filename = `project_${project}_global_vars.csv`
        downloadResponseAsFile(response.data, 'text/csv', filename)
      }
    )
  }, */
  getStatistics(baseline, groupsAndTrials) {
    let trials = groupsAndTrials.filter(e => e.type == 'trial').map(t => t.id)
    let groups = groupsAndTrials.filter(e => e.type == 'group').map(g => g.id)
    return Api.get(
      getEnvVar('VUE_APP_API_URL') + `/statistics/tests/${baseline.type}/${baseline.id}/`, 
        {
          params: {groups: groups, trials: trials},
          paramsSerializer: params => {
            return qs.stringify(params, {arrayFormat: 'repeat'})
          }
        }
      ).then(
        response => {
          return response.data
        }
    )
  },
  getQt(project, trial, subject) {
    return Api.get(
      getEnvVar('VUE_APP_API_URL') + `/outputs/${project}/${trial}/${subject}/qt/`
    ).then(
      response => {return response.data}
    ), error => store.dispatch('setError', error)
  },
  getQrs(project, trial, subject) {
    return Api.get(
      getEnvVar('VUE_APP_API_URL') + `/outputs/${project}/${trial}/${subject}/qrs/`
    ).then(
      response => {return response.data}
    ), error => store.dispatch('setError', error)
  },
  postQt(project, trial, subject, qt) {
    return Api.post(
      getEnvVar('VUE_APP_API_URL') + `/outputs/${project}/${trial}/${subject}/qt/`, qt
    ).then(
      response => {return response.data}
    ), error => store.dispatch('setError', error)
  },
  postQrs(project, trial, subject, qrs) {
    return Api.post(
      getEnvVar('VUE_APP_API_URL') + `/outputs/${project}/${trial}/${subject}/qrs/`, qrs
    ).then(
      response => {return response.data}
    ), error => store.dispatch('setError', error)
  },
  modifySubjectGlobals(project, trial, subject, volGlobals) {
    let volGlobalsJson = JSON.parse(JSON.stringify(volGlobals))
    return Api.post(
      getEnvVar('VUE_APP_API_URL') + `/outputs/${project}/${trial}/${subject}/vol_globals/`, volGlobalsJson
    ).then(
        response => {return response.data}
    ), error => store.dispatch('setError', error)
  }
}
